import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminSendResetButton({ variant = "default" }) {
  const [busy, setBusy] = useState(false);
  const [sentMask, setSentMask] = useState("");
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/self/send-reset");
      setSentMask(data.sent_to_masked || "");
      toast.success("Reset link sent — check your email");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail, "Failed to send reset link"));
    } finally { setBusy(false); }
  };
  const compact = variant === "compact";
  return (
    <div>
      <Button
        onClick={send}
        disabled={busy}
        variant={compact ? "ghost" : "default"}
        className={compact
          ? "w-full justify-start text-slate-200 hover:bg-white/10 hover:text-white text-xs h-8"
          : "bg-[#556B2F] hover:bg-[#2A331A] text-white"}
        data-testid="btn-admin-send-reset"
      >
        <Mail className="h-4 w-4 mr-2" /> {busy ? "Sending..." : "Send reset link to my email"}
      </Button>
      {sentMask && (
        <div className={`text-xs mt-2 ${compact ? "text-slate-300" : "text-emerald-700"}`} data-testid="admin-reset-sent">
          Link sent to <span className="font-mono">{sentMask}</span>
        </div>
      )}
    </div>
  );
}
